<div class="pairing-settings-panel">
  <h4 class="m-b-md"><i class="fa fa-magic"></i> Automatic Settings</h4>

  <div class="row">
    <!-- Column 1: Players & Groups -->
    <div class="col-md-4">
      <div class="form-group">
        <label>Players in Field: <span class="text-danger">*</span></label>
        <input
          type="number"
          class="form-control"
          [(ngModel)]="currentSettings.numberOfPlayers"
          (ngModelChange)="onPlayersChange()"
          min="0"
          placeholder="Enter total players"
        />
        <span class="help-block">Total number of players in the field</span>
      </div>

      <div class="form-group">
        <label>'A' Players:</label>
        <input
          type="number"
          class="form-control"
          [(ngModel)]="currentSettings.numberOfAPlayers"
          (ngModelChange)="onAPlayersChange($event)"
          min="0"
          step="6"
          placeholder="Enter A players"
        />
        @if (aPlayersError()) {
        <span class="help-block text-danger">
          <i class="fa fa-warning"></i> {{ aPlayersError() }}
        </span>
        } @else {
        <span class="help-block">
          Set from Tournament Players → Edit Parameters when available. Value
          must stay divisible by 6.
        </span>
        }
      </div>

      <div class="form-group">
        <label>Players per Group: <span class="text-danger">*</span></label>
        <select
          class="form-control"
          [(ngModel)]="currentSettings.playersPerGroup"
          (ngModelChange)="onPlayersPerGroupChange()"
        >
          <option [ngValue]="1">1</option>
          <option [ngValue]="2">2</option>
          <option [ngValue]="3">3</option>
          <option [ngValue]="4">4</option>
        </select>
      </div>

      <div class="form-group">
        <label
          ># of Groups: <span class="label label-info">Calculated</span></label
        >
        <input
          type="text"
          class="form-control pairing-section-bg"
          [value]="calculatedGroups"
          readonly
        />
      </div>
    </div>

    <!-- Column 2: Tees & Waves -->
    <div class="col-md-4">
      <div class="form-group">
        <label>Number of Tees:</label>
        <select
          class="form-control"
          [(ngModel)]="currentSettings.numberOfTees"
          (ngModelChange)="onTeesChange()"
        >
          <option [ngValue]="1">1</option>
          <option [ngValue]="2">2</option>
        </select>
      </div>

      <div class="form-group">
        <label>Number of Waves:</label>
        <select
          class="form-control"
          [(ngModel)]="currentSettings.numberOfWaves"
          (ngModelChange)="onWavesChange($event)"
        >
          <option [ngValue]="1">1</option>
          <option [ngValue]="2">2</option>
        </select>
      </div>

      <div class="form-group">
        <label
          >Number of Blocks:
          <span class="label label-info">Calculated</span></label
        >
        <input
          type="text"
          class="form-control pairing-section-bg"
          [value]="calculatedBlocks"
          readonly
        />
        <span class="help-block">Tees × Waves</span>
      </div>

      <div class="form-group">
        <label>Extra Grps / Wave:</label>
        <select
          class="form-control"
          [(ngModel)]="currentSettings.extraGroupsPerWave"
        >
          <option value="Even">Even</option>
          <option value="Odd">Odd</option>
        </select>
      </div>

      <div class="form-group">
        <label>Extra Grps / Tee:</label>
        <select
          class="form-control"
          [(ngModel)]="currentSettings.extraGroupsPerTee"
        >
          <option value="Even">Even</option>
          <option value="Odd">Odd</option>
        </select>
      </div>
    </div>

    <!-- Column 3: Times & Sequencing -->
    <div class="col-md-4">
      <div class="form-group">
        <label>1st Wave Start Time: <span class="text-danger">*</span></label>
        <input
          type="time"
          class="form-control"
          [(ngModel)]="currentSettings.firstWaveStartTime"
          required
        />
      </div>

      <div class="form-group">
        <label>2nd Wave Start Time:</label>
        <input
          type="time"
          class="form-control"
          [(ngModel)]="currentSettings.secondWaveStartTime"
          [disabled]="currentSettings.numberOfWaves !== 2"
        />
        @if (currentSettings.numberOfWaves === 2 &&
        !currentSettings.secondWaveStartTime) {
        <span class="help-block text-warning">
          <i class="fa fa-warning"></i> Required when using 2 waves
        </span>
        }
      </div>

      <div class="form-group">
        <label>Interval (Minutes): <span class="text-danger">*</span></label>
        <input
          type="number"
          class="form-control"
          [(ngModel)]="currentSettings.intervalMinutes"
          min="8"
          max="25"
          placeholder="11"
        />
        <span class="help-block">8-25 minutes between groups</span>
      </div>

      <div class="form-group">
        <label>Grp Placement:</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="currentSettings.groupPlacement"
          placeholder="BA|AB"
        />
        <span class="help-block">A/B/C pattern per block</span>
      </div>

      <div class="form-group">
        <label># Sequence:</label>
        <select
          class="form-control"
          [(ngModel)]="currentSettings.numberSequence"
        >
          <option value="Sequential">Sequential</option>
          <option value="Odd/Even">Odd/Even</option>
        </select>
      </div>

      <div class="form-group">
        <label>Starting Grp #:</label>
        <input
          type="number"
          class="form-control"
          [(ngModel)]="currentSettings.startingGroupNumber"
          min="1"
          placeholder="1"
        />
      </div>
    </div>
  </div>

  <!-- Round 2+ Options -->
  <div class="alert alert-info m-t-md">
    <h4><i class="fa fa-info-circle"></i> Round 2+ Settings</h4>
    <p class="text-muted">
      These options apply to subsequent rounds based on standings
    </p>
    <div class="row">
      <div class="col-md-3">
        <div class="checkbox checkbox-primary">
          <input
            type="checkbox"
            id="flipFlop"
            [(ngModel)]="currentSettings.flipFlop"
          />
          <label for="flipFlop">
            <strong>Flip Flop</strong>
            <br /><small class="text-muted">Alternate tee assignments</small>
          </label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="checkbox checkbox-primary">
          <input
            type="checkbox"
            id="repairByScore"
            [(ngModel)]="currentSettings.repairByScore"
          />
          <label for="repairByScore">
            <strong>Repair by Score</strong>
            <br /><small class="text-muted">Pair based on scores</small>
          </label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="checkbox checkbox-primary">
          <input
            type="checkbox"
            id="leadersOff10"
            [(ngModel)]="currentSettings.leadersOff10"
          />
          <label for="leadersOff10">
            <strong>Leaders off 10?</strong>
            <br /><small class="text-muted">Start leaders from 10th</small>
          </label>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>Inverted Type:</label>
          <select
            class="form-control"
            [(ngModel)]="currentSettings.invertedType"
          >
            <option value="All Normal">All Normal</option>
            <option value="All Inverted">All Inverted</option>
            <option value="First Group Normal">First Group Normal</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="row m-t-md">
    <div class="col-lg-12 text-right">
      <button class="btn btn-white" type="button">
        <i class="fa fa-times"></i> Cancel
      </button>
      <button class="btn btn-primary" type="button" (click)="saveSettings()">
        <i class="fa fa-save"></i> Save Settings
      </button>
    </div>
  </div>
</div>
